import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h2 className="text-xl md:text-2xl font-semibold text-foreground-950 mt-6">
          Página não encontrada
        </h2>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">
          A página que você procura não existe ou foi movida.
        </p>
        <div className="mt-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-semibold text-sm rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-300"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line"></i>
            </div>
            Voltar ao Início
          </Link>
        </div>
      </div>
    </div>
  );
}